import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import * as yup from "yup";
import { AuthContext } from "../../../context/AuthContext";

const quickbooksCustomerSchema = yup.object({
  billEmail: yup.string().email("Invalid Email").max(100, "100 characters max"),
});

const SendInvoiceDialog = ({
  invoiceId,
  docNumber,
  subCustomer,
  currentBillingEmail,
  open,
  onClose,
  onSend,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [useDifferentEmail, setUseDifferentEmail] = useState(false);

  const handleClose = () => {
    formik.resetForm();
    setErrorMessage("");
    onClose();
  };

  const initialValues = {
    billEmail: "", // title
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: quickbooksCustomerSchema,
    // enableReinitialize: true,
    onSubmit: () => {
      handleSend(formik.values.billEmail);
    },
  });

  const handleSend = async (billEmail) => {
    try {
      setLoading(true);
      const header = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await ezorder.post(
        `/quickbooks/invoice/${invoiceId}/send`,
        { billEmail },
        header
      );

      if (response.status == 200 || response.status === 201) {
        setErrorMessage("");
        onSend(response.data.customer);
      } else {
        if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.error
        ) {
          setErrorMessage(response.response.data.error);
        } else {
          setErrorMessage("Something went wrong");
        }
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.data?.error) {
          setErrorMessage(error.response.data.error);
        } else {
          setErrorMessage("Internal server error");
        }
      } else {
        setErrorMessage("Internal server error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (formik) console.log(formik.values);
  }, [formik.values]);

  //   useEffect(() => {
  //     if (formik) console.log(formik.errors);
  //   }, [formik.errors]);

  return (
    <Dialog
      fullScreen={isSmallScreen}
      maxWidth="md"
      fullWidth={true}
      open={open}
      onClose={() => {
        if (!loading) handleClose();
      }}
    >
      <DialogTitle>
        Send Invoice #{docNumber} - {subCustomer}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Current Billing Email: {currentBillingEmail}
        </DialogContentText>
        <Box sx={{ display: "flex", flexDirection: "row", marginTop: "8px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              magin: 0,
              padding: 0,
            }}
          >
            <Checkbox
              style={{
                magin: 0,
                padding: 0,
              }}
              checked={formik.values.useDifferentEmail}
              id="useDifferentEmail"
              name="useDifferentEmail"
              onChange={(e) => {
                formik.setValues((prev) => ({
                  ...prev,
                  useDifferentEmail: e.target.checked,
                  billEmail: e.target.checked ? prev.billEmail : "",
                }));
              }}
            />
            <Typography>Update and Send to a New Billing Email</Typography>
          </Box>
        </Box>
        {formik.values.useDifferentEmail && (
          <TextField
            size="small"
            disabled={!formik.values.useDifferentEmail}
            fullWidth
            sx={{ marginTop: "8px" }}
            label="New Billing Email"
            id="billEmail"
            name="billEmail"
            value={formik.values.billEmail}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.billEmail && Boolean(formik.errors.billEmail)}
            helperText={formik.errors.billEmail && `${formik.errors.billEmail}`}
          />
        )}
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          loading={loading}
          disabled={formik.errors && Object.keys(formik.errors).length > 0}
          onClick={() => {
            setErrorMessage("");
            formik.handleSubmit();
          }}
        >
          Send
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default SendInvoiceDialog;
